import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import Routes from "./Routes";

function App() {
  useEffect(() => {
    const GA_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

    if (GA_ID) {
      // Load the GA script
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", GA_ID, {
        page_path: window.location.pathname,
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <Routes />
    </HelmetProvider>
  );
}

export default App;
